/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TwoFactorConfirmRequest } from '../../models/two-factor-confirm-request';
import { TwoFactorRequiredConfirmResult } from '../../models/two-factor-required-confirm-result';

export interface ConfirmRequired$Params {
  authorization: string;
      body: TwoFactorConfirmRequest
}

export function confirmRequired(http: HttpClient, rootUrl: string, params: ConfirmRequired$Params, context?: HttpContext): Observable<StrictHttpResponse<TwoFactorRequiredConfirmResult>> {
  const rb = new RequestBuilder(rootUrl, confirmRequired.PATH, 'post');
  if (params) {
    rb.header('authorization', params.authorization, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TwoFactorRequiredConfirmResult>;
    })
  );
}

confirmRequired.PATH = '/auth/2fa/setup-required/confirm';
